"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldInfo = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var capture_thumbnail_1 = require("../capture.thumbnail/capture.thumbnail");
var capture_thumbnail_style_1 = require("../capture.thumbnail/capture.thumbnail.style");
var CSS = {
    container: 'c-FieldInfo',
    captures: 'c-FieldInfo__Captures',
    stat: {
        container: 'c-FieldInfo__Stat',
        label: 'c-FieldInfo__Stat--label',
        name: 'c-FieldInfo__Stat--name',
        icon: 'c-FieldInfo__Stat--icon',
        value: 'c-FieldInfo__Stat--value'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        width: '100%'
    },
    _a[CSS.stat.container] = {
        width: '100%',
        display: 'flex',
        'justify-content': 'space-between',
        'margin-left': theme_1.DefaultTheme.space(2)
    },
    _a[CSS.stat.label] = {
        flex: 1,
        display: 'flex'
    },
    _a[CSS.stat.icon] = {
        'font-size': theme_1.DefaultTheme.font.size,
        color: theme_1.DefaultTheme.background.mediumGrey,
        'margin-left': theme_1.DefaultTheme.space(1)
    },
    _a[CSS.stat.value] = {
        flex: 1,
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[CSS.captures] = {
        width: '100%',
        display: 'flex',
        'justify-content': 'space-around',
        'margin-top': theme_1.DefaultTheme.space(1),
        'overflow-x': 'auto'
    },
    _a["".concat(CSS.captures, " .").concat(capture_thumbnail_style_1.CSS.container)] = {
        width: '130px',
        'min-width': '130px',
        height: '130px',
        'min-height': '130px'
    },
    _a));
var THUMBNAIL_CTX = {
    crosshair: true,
    title: ''
};
exports.FieldInfo = {
    viewCaptures: function (collection, captures, stats) {
        if (stats === void 0) { stats = []; }
        var captureChildren = [];
        for (var _i = 0, captures_1 = captures; _i < captures_1.length; _i++) {
            var capture = captures_1[_i];
            THUMBNAIL_CTX.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            captureChildren.push(capture_thumbnail_1.CaptureThumbnail.view(collection, capture, THUMBNAIL_CTX));
        }
        var statNodes = [];
        for (var _a = 0, stats_1 = stats; _a < stats_1.length; _a++) {
            var stat = stats_1[_a];
            statNodes.push(exports.FieldInfo.viewStat(stat.name, stat.value));
        }
        return (0, mithril_1.m)('div', { className: CSS.container }, tslib_1.__spreadArray(tslib_1.__spreadArray([], statNodes, true), [
            (0, mithril_1.m)('div', { className: CSS.captures }, captureChildren)
        ], false));
    },
    viewStat: function (name, value) {
        var displayValue;
        if (typeof value === 'number') {
            displayValue = core_shared_1.IkeUnit.display(value, services_1.Services.UserSettings.units);
        }
        else {
            displayValue = value;
        }
        return (0, mithril_1.m)('div', { className: CSS.stat.container }, [
            (0, mithril_1.m)('div', { className: CSS.stat.label }, (0, i18n_1.Translate)(name)),
            (0, mithril_1.m)('span', { className: CSS.stat.value }, displayValue)
        ]);
    },
    viewVectorInline: function (value) {
        var length = core_shared_1.IkeUnit.display(value.distance, services_1.Services.UserSettings.units, core_shared_1.IkeUnit.METER);
        var angle = core_shared_1.IkeUnit.display(value.bearing, core_shared_1.IkeUnit.DEGREE, core_shared_1.IkeUnit.RADIAN);
        return (0, i18n_1.Translate)(i18n_1.T.FIELD_VECTOR_P2P_DISPLAY, { length: length, angle: angle });
    }
};
//# sourceMappingURL=field.info.js.map